import React from "react";
import PropTypes from "prop-types";
import { confirmable } from "react-confirm";
import { Row, Col } from "react-bootstrap";
import { createConfirmation } from "react-confirm";
import { CdsActionModal } from "clayco-component-library";

import "../../../styles/confirm-modal.scss";

const confirmDlg = ({
    confirmation,
    proceedLabel,
    cancelLabel,
    show,
    proceed,
}) => (
    <div className="confirm-modal">
        <CdsActionModal
            show={show}
            handleCloseClick={() => proceed(false)}
            primaryButtonText={proceedLabel}
            primaryButtonAction={() => proceed(true)}
            secondaryButtonText={cancelLabel}
            secondaryButtonAction={() => proceed(false)}
        >
            <Row className="p-4" style={{ maxWidth: "500px" }}>
                <Col>
                    <p className="text-center">{confirmation}</p>
                </Col>
            </Row>
        </CdsActionModal>
    </div>
);

confirmDlg.propTypes = {
    show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
    proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
    confirmation: PropTypes.string, // arguments of your confirm function
    options: PropTypes.object, // arguments of your confirm function
};

export function ConfirmDlg(
    confirmation,
    proceedLabel = "Ok",
    cancelLabel = "Cancel",
    options = {},
    show
) {
    return createConfirmation(confirmable(confirmDlg))({
        confirmation,
        proceedLabel,
        cancelLabel,
        ...options,
    });
}
